/**
 * @generated SignedSource<<c691598616878362b73526082636fffb>>
 * @relayHash 22a043234be95fa20e060d60e168d985
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a27e98c00c60c5125bb9573000f3e2184fa0546ddf6338da0ee78c015eada92b

import type { ConcreteRequest } from 'relay-runtime';
export type useConfluenceAutomationNudgeActionsQuery$variables = {
  contentId: string;
  isDraft: boolean;
  skipContentReviewerNudge: boolean;
  skipStatusUpdatesAutomation: boolean;
  skipUserEmails: boolean;
};
export type useConfluenceAutomationNudgeActionsQuery$data = {
  readonly singleContent: {
    readonly __typename: "Content";
    readonly ancestors?: ReadonlyArray<{
      readonly id: string | null;
      readonly title: string | null;
    } | null> | null;
    readonly children?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly metadata: {
          readonly createdDate: string | null;
        };
        readonly title: string | null;
      } | null> | null;
    } | null;
    readonly contentState?: {
      readonly id: string | null;
      readonly name: string;
    } | null;
    readonly history?: {
      readonly ownedBy: {
        readonly accountId?: string | null;
      } | null;
    } | null;
    readonly id: string | null;
    readonly metadata?: {
      readonly sourceTemplateEntityId: string | null;
    };
    readonly space?: {
      readonly id: string | null;
    } | null;
    readonly title?: string | null;
  } | null;
  readonly user: {
    readonly __typename: "AtlassianUser";
    readonly emails?: ReadonlyArray<{
      readonly isPrimary: boolean | null;
      readonly value: string | null;
    } | null> | null;
    readonly id: string | null;
  } | null;
};
export type useConfluenceAutomationNudgeActionsQuery = {
  response: useConfluenceAutomationNudgeActionsQuery$data;
  variables: useConfluenceAutomationNudgeActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipContentReviewerNudge"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipStatusUpdatesAutomation"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipUserEmails"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "condition": "skipUserEmails",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "AtlassianUserEmail",
          "kind": "LinkedField",
          "name": "emails",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "value"
            },
            {
              "kind": "ScalarField",
              "name": "isPrimary"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v9 = {
  "condition": "skipContentReviewerNudge",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDraft",
          "variableName": "isDraft"
        }
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "title"
},
v11 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ]
},
v12 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v10/*: any*/)
  ]
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v14 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "sourceTemplateEntityId"
    }
  ]
},
v15 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 25
    }
  ],
  "concreteType": "PaginatedContentList",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        (v10/*: any*/),
        {
          "concreteType": "ContentMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "createdDate"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "children(first:25)"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          {
            "condition": "skipStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/)
                    ]
                  }
                ]
              },
              (v14/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "selections": [
      (v7/*: any*/),
      {
        "args": (v8/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          {
            "condition": "skipStatusUpdatesAutomation",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ]
              },
              (v14/*: any*/),
              (v15/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "22a043234be95fa20e060d60e168d985",
    "id": "a27e98c00c60c5125bb9573000f3e2184fa0546ddf6338da0ee78c015eada92b",
    "metadata": {},
    "name": "useConfluenceAutomationNudgeActionsQuery",
    "operationKind": "query",
    "text": "query useConfluenceAutomationNudgeActionsQuery($contentId:ID!,$skipStatusUpdatesAutomation:Boolean!,$skipContentReviewerNudge:Boolean!,$skipUserEmails:Boolean!,$isDraft:Boolean!){user:confluence_atlassianUser(current:true){__typename,id,emails@skip(if:$skipUserEmails){value,isPrimary}},singleContent(id:$contentId){__typename,id,contentState(isDraft:$isDraft)@skip(if:$skipContentReviewerNudge){id,name},title@skip(if:$skipStatusUpdatesAutomation)\n    space@skip(if:$skipStatusUpdatesAutomation){id}\n    ancestors@skip(if:$skipStatusUpdatesAutomation){id,title}\n    history@skip(if:$skipStatusUpdatesAutomation){ownedBy{__typename,...on KnownUser{accountId}}}\n    metadata@skip(if:$skipStatusUpdatesAutomation){sourceTemplateEntityId}\n    children(first:25)@skip(if:$skipStatusUpdatesAutomation){nodes{id,title,metadata{createdDate}}}}}"
  }
};
})();

(node as any).hash = "afe62dfdde51fc06658664d145c28bd1";

export default node;
